import { AllHTMLAttributes, useEffect, useMemo } from 'react';
import slugify from 'slugify';

import { Container, Flex } from '@grupoboticario/flora-react';

import { app, catalog } from 'core';
import { AVAILABLE_OPTION, Catalog } from 'core/domains/catalog.d';
import { useScrollToElement } from 'ui/hooks';
import { ProductsCarousel } from 'ui/components/Showcases';
import { HeadingWithButton } from 'ui/components/HeadingWithButton';
import { ErrorComponent } from 'ui/components';

import Styles from './Showcase.styles';

import { ShowcaseSkeleton } from './Showcase.skeleton';

export const Showcase = ({
  title = '',
  tracking,
  queryOptions,
  ...props
}: { queryOptions: Catalog['queryOptions'] } & AllHTMLAttributes<HTMLElement> & {
    tracking?: {
      section?: string;
    };
  }) => {
  useScrollToElement();
  const isMobile = app.hooks.useApp('isMobile');
  const query = useMemo(
    () => ({
      availability: AVAILABLE_OPTION.first,
      ...queryOptions,
    }),
    [queryOptions],
  );
  const { data, isLoading, isError, isSuccess } = catalog.hooks.useCatalog(query);

  if (isSuccess && !data.length) {
    return <div data-testid="showcase"></div>;
  }

  return (
    <Styles.SectionWrapper {...props} data-testid="showcase">
      <Container size="large">
        <Flex direction="column" gap="$5">
          {!isLoading && isSuccess && <HeadingWithButton title={title} />}
          {!isLoading && isError && (
            <ErrorComponent.ReloadPage
              title={`Tivemos um problema para exibir ${title}`}
              data-autotagging-flora-section={tracking?.section ?? slugify(title, { lower: true })}
            />
          )}
          {isLoading && <ShowcaseSkeleton />}
          {!isLoading && isSuccess && Boolean(data.length) && (
            <ProductsCarousel isMobile={isMobile} data={data} />
          )}
        </Flex>
      </Container>
    </Styles.SectionWrapper>
  );
};
